import { SET_FORECAST_MAINTENANCE_AND_GROWTH_CAPEX } from "./mutations";
import {store} from "../../index";
import ForecastedMaintenanceGrowthCapex from "../../../models/valuation/ForecastedMaintenanceGrowthCapex";
import { generateForecastedRevenue } from "../valuation/actions";

export const generateForecastMaintenanceAndGrowthCapex = (options = { clearCache: false }) => (dispatch) => {
  dispatch(generateForecastedRevenue())
  
  const { forecastMGC, taxes } = store.getState()
  const { forecastedRevenue } = store.getState().valuation;

  const { forecastMaintenanceAndGrowthCapex } = forecastMGC
  const growthRateMultiplier = (taxes.growthRate / 100) + 1

  if (forecastMaintenanceAndGrowthCapex && !options.clearCache) {
    dispatch({
      type: SET_FORECAST_MAINTENANCE_AND_GROWTH_CAPEX,
      payload: new ForecastedMaintenanceGrowthCapex({
        ...forecastMaintenanceAndGrowthCapex,
        growthRate: growthRateMultiplier,
        forecastedRevenue: forecastedRevenue?.forecastedValue
      })
    })

    return
  }

  dispatch({
    type: SET_FORECAST_MAINTENANCE_AND_GROWTH_CAPEX,
    payload: new ForecastedMaintenanceGrowthCapex({
      growthRate: growthRateMultiplier,
      forecastedRevenue: forecastedRevenue?.forecastedValue,
    })
  })
}

export const updateForecastMaintenanceAndGrowthCapex = ({ capexPercentageRevenue, analystNote }) => (dispatch) => {
  const storedForecastMaintenanceAndGrowthCapex = new ForecastedMaintenanceGrowthCapex({
    ...store.getState().forecastMGC.forecastMaintenanceAndGrowthCapex
  })

  if (capexPercentageRevenue) storedForecastMaintenanceAndGrowthCapex.capexPercentageRevenue = capexPercentageRevenue
  if (analystNote || analystNote === "") storedForecastMaintenanceAndGrowthCapex.analystNote = analystNote

  dispatch({
    type: SET_FORECAST_MAINTENANCE_AND_GROWTH_CAPEX,
    payload: new ForecastedMaintenanceGrowthCapex({
      ...storedForecastMaintenanceAndGrowthCapex
    })
  })
}

